import { render, staticRenderFns } from "./FeatureCard.vue?vue&type=template&id=9495f9a6&scoped=true&"
import script from "./FeatureCard.vue?vue&type=script&lang=js&"
export * from "./FeatureCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9495f9a6",
  null
  
)

export default component.exports